export const toLocalStorage = (key, value) => {
  window.localStorage[key] = JSON.stringify(value)
}

export const fromLocalStorage = (key, defaultValue = undefined) => {
  try {
    if (window.localStorage[key]) {
      return JSON.parse(window.localStorage[key])
    }
    // eslint-disable-next-line
  } catch (_e) {
    window.localStorage[key] = undefined
  }
  return defaultValue
}
